// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../../../types';

import gql from 'graphql-tag';
import { GetSpaceCapacityEventFragmentDoc, GetSpaceCapacityProposalFragmentDoc } from '../../../../../../Graphql-Utilities/getSpaceCapacity/getSpaceCapactiy.generated-types';
import { ProposalModalEventFragmentDoc, ProposalModalProposalFragmentDoc } from '../../../../ProposalModal/ProposalModal.generated-types';
import { UseDateTimeDurationEventFragmentDoc } from '../../../../../../Hooks/useDateTimeDuration/useDateTimeDuration.generated-types';
import { GetStatusesEventFragmentDoc } from '../../../../../../Graphql-Utilities/getStatuses/getStatuses.generated-types';
import { GetAddressProposalFragmentDoc } from '../../../../../../Graphql-Utilities/getAddress/getAddress.generated-types';
export type ProposalCardContentEventFragment = { __typename?: 'Event', currency: string, firstProposalsSentToGuestAt?: string | null, layoutID: string, fromDateTime: string, toDateTime: string, proposalCount: number, status: Types.EventStatus };

export type ProposalCardContentProposalFragment = { __typename?: 'Proposal', status: Types.ProposalStatus, hasPreferredVenue: boolean, ID: number, currency: string, baseCostTotal: number, baseCostDescription: string, message?: string | null, space: { __typename?: 'SelfServeSpace', spaceName?: string | null, description?: string | null, tour3dUrl?: string | null, spacePhotos?: Array<{ __typename?: 'SelfServeSpacePhoto', url?: string | null }> | null, venue?: { __typename?: 'SelfServeVenue', name?: string | null, addressLine1?: string | null, city?: string | null, postalCode?: string | null, nearestTransit?: { __typename?: 'NearestTransit', station?: string | null, distanceKm?: number | null } | null } | null, spatialConfigurations?: Array<{ __typename?: 'SelfServeSpatialConfiguration', name?: string | null, capacity?: number | null }> | null, spaceFeatures?: Array<{ __typename?: 'SelfServeSpaceFeature', ID?: number | null, name?: string | null }> | null }, extraCostItems?: Array<{ __typename?: 'ExtraCostItem', ID: number, description: string, quantity?: number | null, costPerUnit: number }> | null, documents?: Array<{ __typename?: 'ProposalDocument', ID: number, URL: string, filename: string }> | null };

export const ProposalCardContentEventFragmentDoc = gql`
    fragment ProposalCardContentEvent on Event {
  currency
  firstProposalsSentToGuestAt
  ...GetSpaceCapacityEvent
  ...ProposalModalEvent
  ...UseDateTimeDurationEvent
  ...GetStatusesEvent
}
    ${GetSpaceCapacityEventFragmentDoc}
${ProposalModalEventFragmentDoc}
${UseDateTimeDurationEventFragmentDoc}
${GetStatusesEventFragmentDoc}`;
export const ProposalCardContentProposalFragmentDoc = gql`
    fragment ProposalCardContentProposal on Proposal {
  status
  space {
    spaceName
    spacePhotos {
      url
    }
    venue {
      name
      nearestTransit {
        station
        distanceKm
      }
    }
  }
  hasPreferredVenue
  ...GetSpaceCapacityProposal
  ...GetAddressProposal
  ...ProposalModalProposal
}
    ${GetSpaceCapacityProposalFragmentDoc}
${GetAddressProposalFragmentDoc}
${ProposalModalProposalFragmentDoc}`;